<template>
    <RouterView />
    <UnauthorizedAccessDialog />
    <VueQueryDevtools button-position="bottom-left" />
    <Toast position="top-right" />
    <Toast position="bottom-right" group="signalr" />
</template>

<script setup lang="ts">
    import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
    import { Toast } from 'primevue';
</script>
